<template>
    <div class="dx-field history-btn-search">
        <DxButton text="Искать" type="default" @click="searchHistory" />
        <span class="ctx-label">по контексту</span>
        <DxSwitch v-model:value="use_context" />
    </div>
</template>

<script setup>
import DxButton from 'devextreme-vue/button';
import { DxSwitch } from 'devextreme-vue/switch';

import { inject } from 'vue';

// для передачи "наверх" намерения начать поиск
const click_counter = inject('click_counter');
const use_context = inject('use_context');

const searchHistory = async () => {
    click_counter.value = click_counter.value + 1;
};

</script>

<style scoped>
.history-btn-search {
    margin-top: 19px;
    height: 32px;
    display: flex;
    flex-direction: row;
}

.ctx-label {
    padding: 7px 10px 0 20px;
}

.history-btn-search .dx-switch {
    margin-top: 6px;
    margin-right: 10px;
}

.history-btn-search .dx-button {
    height: 32px;
    flex-grow: 1;
}
</style>
